<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_loandisbursement'] == 1 && userData.permissions['view_loans'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <span class="d-flex justify-content-between mb-2">
              <div class="d-flex justify-content-between">
                <div><label>From</label><input class="form-control" v-model="date_from" type="date"></div>
                <div class="mx-1"><label>To</label><input class="form-control" v-model="date_to" type="date"></div>
                <div class="mt-4"><b-button variant="primary" @click="FilterData"><i class="mdi mdi-filter"></i>
                    Filter</b-button></div>
              </div>
            </span>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy">
                <template #table-busy>
                  <div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow"
                      small></b-spinner> <strong>No Data Found</strong></div>
                </template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(memberid)="data">
                  <b class="text-info">{{ data.item.member.member_id }}</b>
                </template>
                <template #cell(member)="data">
                  <router-link :to="{
                    path: '/memberprofile',
                    query: { id: data.item.member.member_id },
                  }">
                    <span @mouseover="name_hover = true; current_index = data.index" @mouseout="name_hover = false">
                      <span
                        :class="(name_hover && current_index == data.index) ? 'fw-bold text-dark text-decoration-underline' : 'text-dark'">{{
                          data.item.member.name }}</span>
                      <span class="d-block text-info fw-bold">{{ data.item.member.member_id }}</span>
                    </span>
                  </router-link>
                </template>
                <template #cell(loan_type)="data">
                  <b><span class="text-info">{{ data.item.loan_type.name }}</span> <br>
                    <small>{{ data.item.loan_type.rate }}%</small> &nbsp;&nbsp;&nbsp;
                    <small>{{ data.item.loan_type.period }}days</small></b>
                </template>
                <template #cell(amount)="data">
                  {{ commas(data.item.amount) }}
                </template>
                <template #cell(charges)="data">
                  {{ commas(data.item.charges) }}
                </template>
                <template #cell(interest)="data">
                  {{ commas(data.item.interest) }}
                </template>
                <template #cell(payback)="data">
                  {{ commas(data.item.payback) }}
                  <small class="d-block text-info fw-bold mt-1">{{ commas(data.item.repaymentplan) }} /{{
                    data.item.repaymentstructure }}</small>
                </template>
                <template #cell(repaymentplan)="data">
                  {{ commas(data.item.repaymentplan) }} /{{ data.item.repaymentstructure }}
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                    <b-button v-show="userData.permissions['approve_loandisbursement'] == 1"
                      @click="approve(data.item.id, data.item.member, data.item.amount, data.item.charges, data.item.interest, data.item.payback, data.item.loan_type.period, data.item.applicationdate)"
                      type="button" class="btn-sm" variant="info" title="Approve" v-b-modal.edit><i
                        class="mdi mdi-checkbox-marked-outline"></i></b-button>
                    <b-button v-show="userData.permissions['decline_loandisbursement'] == 1"
                      @click="remove(data.item.id, data.item.member.name)" type="button" class="btn-sm btn"
                      variant="danger" v-b-modal.delete title="Decline"> <i class="mdi mdi-close"></i> </b-button>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <b>Total Loans : {{ commas(totalloan) }}</b>
              </div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to view Loan Disbursements</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="approve-disbursement" size="xl" centered title="Are you sure you want to Approve Loan Disbursement"
      title-class="font-14" hide-footer>
      <form @submit.prevent="approveLoanDisbursement">
        <div class="row">
        <div class="form-group col-md-4">
          <label class="mb-0">Member</label>
          <input type="text" class="form-control text-info mb-2" style="background: none;" readonly
            v-model="membername">
        </div>
          <div class="form-group col-md-4">
            <label class="mb-0">Loan Amount</label>
            <input type="text" class="form-control text-info mb-2" style="background: none;" readonly v-model="amount">
          </div>
          <div class="form-group col-md-4">
            <label class="mb-0">Interest</label>
            <input type="text" class="form-control text-info mb-2" style="background: none;" readonly
              v-model="interest">
          </div>
          <div class="form-group col-md-4">
            <label class="mb-0">Payback</label>
            <input type="text" class="form-control text-info mb-2" style="background: none;" readonly v-model="payback">
          </div>
          <!-- Other SACCOs -->
          <div class="col-md-4" v-if="userData.member.business != 5">
            <label for="net_amount" class="mb-0">Net Amount <i class="px-1 m-0 mdi mdi-help"
                style="background-color: gainsboro; border-radius: 100%;"
                @mouseover="charges_tooltip = true; removeAllCommas();"
                @mouseout="charges_tooltip = false; addAllCommas();"></i></label>
            <div class="border border-dark rounded shadow-lg d-block p-2 mt-1 fw-bold bg-white text-dark"
              v-if="charges_tooltip" style="position: absolute; z-index: 100;"><small>{{ commas(charges) }}
                charges</small>
            </div>
            <input id="net_amount" type="text" readonly class="form-control text-info mb-2" style="background: none;"
              v-model="net_amount">
          </div>
          <!-- End of Other SACCOs -->

          <!-- Ivan's SACCO -->
          <div class="col-md-4" v-else>
            <label for="net_amount" class="mb-0">Net Amount <i class="px-1 m-0 mdi mdi-help"
                style="background-color: gainsboro; border-radius: 100%;"
                @mouseover="charges_tooltip = true; removeAllCommas();"
                @mouseout="charges_tooltip = false; addAllCommas();"></i></label>
            <div class="border border-dark rounded shadow-lg d-block p-2 mt-1 fw-bold bg-white text-dark"
              v-if="charges_tooltip" style="position: absolute; z-index: 100;"><small>{{ commas(charges) }} charges to
                reflect as Savings</small>
            </div>
            <input id="net_amount" type="text" readonly class="form-control text-info mb-2" style="background: none;"
              v-model="net_amount">
          </div>
          <!-- End of Ivan's SACCO -->

        <div class="form-group col-md-4 mb-2">
          <label class="mb-0">Mode of Payment</label> <small class="text-danger">*</small>
          <v-select :options="paymentoptions" placeholder="Select an Option" v-model="mode_of_payment" label="name"
            :reduce="mode_of_payment => mode_of_payment.id"></v-select>
        </div>
        <div class="form-group col-md-12 mb-2">
          <label class="mb-0">Reference</label>
          <textarea v-model="reference" rows="2" class="form-control"></textarea>
        </div>
        <div class="form-group col-md-4 mb-2">
          <label class="mb-0">Application Date</label>
          <input type="date" class="form-control text-info mb-2" style="background: none;" readonly
            v-model="application_date">
        </div>
        <div class="form-group col-md-4 mb-2">
          <label class="mb-0">Disbursement Date</label>
          <input type="date" class="form-control text-info mb-2" :max="currentdate" v-model="disbursement_date"
            @change="calculateFullRepayDate">
        </div>
        <div class="form-group col-md-4 mb-2">
          <label class="mb-0">Full Repayment Date <span id="message-box"
              class="fade d-none badge rounded-pill bg-primary text-light fw-bold">+ {{ loan_period }}
              days</span></label>
          <input type="date" class="form-control text-info mb-3" v-model="expirydate">
        </div>
        </div>
        <small class="text-danger">{{ saveError }}</small>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('approve-disbursement')">Close</b-button>
          <b-button type="submit" :disabled="saveBtn" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i> Submit</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="delete-disbursement" centered title="Decline Loan Disbursement" title-class="font-18" hide-footer>
      <form @submit.prevent="removeLoanDisbursement">
        <input v-model="id" type="hidden">
        Are you sure you want to decline the Loan Disbursement for : <b>{{ membername }}</b> ?
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('delete-disbursement')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            YES</b-button>
        </div>
      </form>
    </b-modal>


    <b-modal id="get-excel-file" centered title="Loan Disbursement Template" title-class="font-18" hide-footer>
      <form @submit.prevent="getExcelFile">
        <label>Loan Type</label>
        <v-select :options="loantypes" required placeholder="Select an Option" v-model="loantype" label="name"
          :reduce="loantype => loantype.id"></v-select>
        <hr>
        <div class="row align-items-center">
          <div class="col-3 border-end border-success">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 48 48">
              <path fill="#4CAF50" d="M41,10H25v28h16c0.553,0,1-0.447,1-1V11C42,10.447,41.553,10,41,10z"></path>
              <path fill="#FFF"
                d="M32 15H39V18H32zM32 25H39V28H32zM32 30H39V33H32zM32 20H39V23H32zM25 15H30V18H25zM25 25H30V28H25zM25 30H30V33H25zM25 20H30V23H25z">
              </path>
              <path fill="#2E7D32" d="M27 42L6 38 6 10 27 6z"></path>
              <path fill="#FFF"
                d="M19.129,31l-2.411-4.561c-0.092-0.171-0.186-0.483-0.284-0.938h-0.037c-0.046,0.215-0.154,0.541-0.324,0.979L13.652,31H9.895l4.462-7.001L10.274,17h3.837l2.001,4.196c0.156,0.331,0.296,0.725,0.42,1.179h0.04c0.078-0.271,0.224-0.68,0.439-1.22L19.237,17h3.515l-4.199,6.939l4.316,7.059h-3.74V31z">
              </path>
            </svg>
          </div>
          <div class="col">
            <div><span class="fw-bold">File: </span> Loan Disbursement Template</div>
            <br>
            <div>
              <div v-if="loader" class="progress">
                <div class="progress-bar" role="progressbar"> {{ progress }}% </div>
              </div>
              <div v-if="loader"><small class="text-success fw-bold">Generating file ....</small></div>
            </div>
          </div>

        </div>
        <br>
        <div class="d-flex justify-content-end">
          <button @click.prevent="$bvModal.hide('get-excel-file')" class="btn btn-outline-danger btn-sm fw-bold">Forget
            it</button>
          <button type="submit" :class="{ disabled: !loantype }"
            class="mx-3 btn btn-sm btn-success fw-bold">Download</button>
        </div>
      </form>
    </b-modal>


    <b-modal id="import-applications" centered title="Import Loan Disbursements" title-class="font-18" hide-footer>
      <form @submit.prevent="importApplications" enctype="multipart/form-data">
        <label>Loan Type <small class="text-success">Check file</small></label>
        <v-select :options="loantypes" required placeholder="Select an Option" v-model="loantype" label="name"
          :reduce="loantype => loantype.id"></v-select>
        <hr>
        <div class="row align-items-center">
          <div class="col-3 border-end border-success">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 48 48">
              <path fill="#4CAF50" d="M41,10H25v28h16c0.553,0,1-0.447,1-1V11C42,10.447,41.553,10,41,10z"></path>
              <path fill="#FFF"
                d="M32 15H39V18H32zM32 25H39V28H32zM32 30H39V33H32zM32 20H39V23H32zM25 15H30V18H25zM25 25H30V28H25zM25 30H30V33H25zM25 20H30V23H25z">
              </path>
              <path fill="#2E7D32" d="M27 42L6 38 6 10 27 6z"></path>
              <path fill="#FFF"
                d="M19.129,31l-2.411-4.561c-0.092-0.171-0.186-0.483-0.284-0.938h-0.037c-0.046,0.215-0.154,0.541-0.324,0.979L13.652,31H9.895l4.462-7.001L10.274,17h3.837l2.001,4.196c0.156,0.331,0.296,0.725,0.42,1.179h0.04c0.078-0.271,0.224-0.68,0.439-1.22L19.237,17h3.515l-4.199,6.939l4.316,7.059h-3.74V31z">
              </path>
            </svg>
          </div>
          <div class="col">
            <label for="">Upload Excel File</label>
            <input class="form-control" accept=".xls,.xlsx" type="file" @change.prevent="handleFileUpload"> <br>
            <!-- Progress bar -->
            <div v-if="uploading">
              <div class="progress">
                <div class="progress-bar" role="progressbar" :style="{ width: uploadProgress + '%' }"
                  :aria-valuenow="uploadProgress" aria-valuemin="0" aria-valuemax="100">
                  {{ uploadProgress }}%
                </div>
              </div>
            </div>
          </div>

        </div>
        <br>
        <div class="d-flex justify-content-end">
          <button @click.prevent="$bvModal.hide('import-applications')"
            class="btn btn-outline-danger btn-sm fw-bold">Forget
            it</button>
          <button type="submit" :class="{ disabled: !loantype }"
            class="mx-3 btn btn-sm btn-success fw-bold">Uplaod</button>
        </div>
      </form>
    </b-modal>


    <b-modal id="errors" title="Errors" centered title-class="font-18" hide-footer>
      <div class="text-danger">{{ errors }}</div>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { loandisbursementMethods, loandisbursementComputed, paymentoptionMethods, paymentoptionComputed, loantypeMethods, loantypeComputed } from "@/state/helpers";
import { formatNumber, removeCommas } from '@/numberUtils';

export default {
  page: {
    title: "Loan Disbursements",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  components: {
    Layout, PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Loan Disbursements",
      items: [{ text: "Dashboard", to: "/", }, { text: "Loan Disbursements", active: true, },],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: 'index', label: '#', visible: true },
        { key: 'id', label: 'ID', visible: false },
        // { key: 'memberid', label: 'Member ID', visible: true },
        { key: 'member', label: 'Name', visible: true },
        { key: 'loan_type', label: 'Loan Product', visible: true },
        { key: 'amount', label: 'Amount', visible: true },
        { key: 'charges', label: 'Charges', visible: true },
        { key: 'interest', label: 'Interest', visible: true },
        { key: 'payback', label: 'Payback', visible: true },
        // { key: 'repaymentplan', label: 'Repayment Plan', visible: true },
        { key: 'disbursement_date', label: 'Disbursement Date', visible: true },
        { key: 'actions', label: 'Actions', visible: true },
      ],
      id: '',
      member: '',
      amount: '',
      charges: '',
      disbursement_date: new Date().toLocaleDateString('fr-CA'),
      application_date: '',
      membername: '',
      payback: '',
      rate: '',
      period: '',
      loan_rate: '',
      loan_period: '',
      loantype: '',
      interest: '',
      mode_of_payment: '',
      reference: '',
      expirydate: new Date(),
      saveBtn: false,
      saveError: '',
      currentdate: new Date().toLocaleDateString('fr-CA'),
      date_to: new Date().toLocaleDateString('fr-CA'),
      date_from: new Date().toLocaleDateString('fr-CA'),
      loader: false,
      progress: 0,
      import_file: '',
      errors: '',
      uploading: false,
      uploadProgress: 0,
      name_hover: false,
      current_index: '',
      net_amount: '',
      charges_tooltip: false,
    };
  },
  computed: {
    ...loandisbursementComputed,
    ...paymentoptionComputed,
    ...loantypeComputed,
    List() { return this.loandisbursements.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.loandisbursements.map((d) => ({ ...d })) },
    IsBusy() { let a = false; if (this.loandisbursements.length > 0) { a = false; } else { a = true; } return a },
    totalloan() { var total = 0; this.loandisbursements.forEach((item) => { var item_total = item.amount; total = Number(total) + Number(item_total); }); return total },
  },
  mounted() {
    this.fetchPaymentoptions();
    this.fetchLoanTypes();
    this.fetchLoanDisbursements();
    this.TotalRows = this.loandisbursements.length;
    this.isBusy = false;
  },
  methods: {
    ...loantypeMethods,
    ...loandisbursementMethods,
    ...paymentoptionMethods,
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    addAllCommas() {
      this.amount = formatNumber(this.amount);
      this.net_amount = formatNumber(this.net_amount);
      this.interest = formatNumber(this.interest);
      this.payback = formatNumber(this.payback);
    },
    removeAllCommas() {
      this.amount = removeCommas(this.amount);
      this.net_amount = removeCommas(this.net_amount);
      this.interest = removeCommas(this.interest);
      this.payback = removeCommas(this.payback);
    },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },

    approve(id, member, amount, charges, interest, payback, loanperiod, applicationdate) {
      this.id = id;
      this.member = member.member_id;
      this.membername = member.name;
      this.amount = amount;
      if (this.userData.member.business != 5) {
        this.charges = charges;
        this.net_amount = Number(amount) - Number(charges);
      } else {
        this.charges = Math.ceil(0.02 * Number(amount));
        this.net_amount = Number(amount) - Number(this.charges);
      }
      this.interest = interest;
      this.payback = payback;
      this.loan_period = loanperiod;
      this.application_date = applicationdate;
      var date = new Date(this.disbursement_date);
      date.setTime(date.getTime() + (loanperiod * 24 * 60 * 60 * 1000));
      this.expirydate = date.toLocaleDateString('fr-CA');
      this.addAllCommas();
      this.$bvModal.show('approve-disbursement')
    },

    showTimeMessage() {
      const messageBox = document.getElementById('message-box');
      messageBox.classList.remove('d-none');
      setTimeout(() => {
        messageBox.classList.add('show');
      }, 20); // Slight delay to allow for transition

      setTimeout(() => {
        messageBox.classList.remove('show');
        setTimeout(() => {
          messageBox.classList.add('d-none');
        }, 1000); // Match the duration of the fade-out transition
      }, 1500); // Keep the message visible for 1.5 seconds
    },

    calculateFullRepayDate() {
      var date = new Date(this.disbursement_date);
      date.setTime(date.getTime() + (this.loan_period * 24 * 60 * 60 * 1000));
      this.expirydate = date.toLocaleDateString('fr-CA');
      this.showTimeMessage();
    },

    remove(id, member) {
      this.id = id;
      this.membername = member;
      this.$bvModal.show('delete-disbursement')
    },
    async approveLoanDisbursement() {
      this.saveBtn = true;
      this.saveError = "Saving Loan Disbursement";
      let formData = new FormData();
      this.removeAllCommas()
      formData.append("id", this.id);
      formData.append("disbursement_date", this.disbursement_date);
      formData.append("expirydate", this.expirydate);
      formData.append("mode_of_payment", this.mode_of_payment);
      formData.append("reference", this.reference);
      formData.append('charges', this.charges);
      let url = "/approveloandisbursement";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchLoanDisbursements();
          this.saveBtn = false;
          this.saveError = "";
          this.$bvModal.hide('approve-disbursement');
        }
      });
    },
    async removeLoanDisbursement() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removeloandisbursement";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchLoanDisbursements();
          this.$bvModal.hide('delete-disbursement');
        }
      });
    },

    getExcelModal() {
      this.loantype = '';
      this.application_date = new Date().toLocaleDateString('fr-CA');
      this.$bvModal.show('get-excel-file');
    },

    async getExcelFile() {
      this.loader = true;
      this.progress = 0;
      let formData = new FormData();
      formData.append('loan_type', this.loantype);
      let url = 'download-disbursement-template';


      await axios.post(url, formData, {
        onDownloadProgress: (progressEvent) => {
          this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        },
        responseType: 'blob', // To handle the file download
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Loan_Disbursements.xlsx'); // Replace with your desired file name
        document.body.appendChild(link);
        link.click();
        link.remove();
      }).catch((error) => {
        alert('Error downloading file:', error);
      }).finally(() => {
        this.loader = false;
      });
    },

    getImportModal() {
      this.loantype = '';
      this.application_date = new Date().toLocaleDateString('fr-CA');
      this.$bvModal.show('import-applications');
    },

    handleFileUpload(event) {
      this.import_file = event.target.files[0]
    },

    async importApplications() {

      if (!this.import_file) {
        alert('Please select a file.');
        return;
      }
      this.uploadProgress = 0;
      this.uploading = true
      this.errors = ''
      let url = '/import-disbursements'
      let obj = {
        loan_type: this.loantype,
        file: this.import_file
      }

      await axios.post(url, obj, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: progressEvent => {
          this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        },
      }).then(response => {
        if (response.data.success) {
          this.$toast.success(response.data.success)
          this.selectedFile = 0;
          this.uploadProgress = 0;
          this.fetchLoanDisbursements();
        }
        else {
          this.errors = response.data.errors || 'Error occured!'
          this.$bvModal.show('errors')
          this.uploadProgress = 0;
        }
      });
    },

    FilterData() {
      this.filterLoanDisbursements({ datefrom: this.date_from, dateto: this.date_to });
    },
  },
};
</script>